import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
export const LikeButton = styled.button`
  border: 1px solid transparent;
  font-family: ${({
  theme
}) => theme.fonts.primary};
  cursor: pointer;
  appearance: none;
  outline: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 100%;
  height: 48px;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 800;
  background-color: transparent;
  color: ${({
  theme
}) => theme.secondary.dark};
  border-color: ${({
  theme
}) => theme.tertiary.dark};

  &:hover {
    color: ${({
  theme
}) => theme.primary.main};
    border-color: ${({
  theme
}) => theme.primary.main};
    path {
      fill: ${({
  theme
}) => theme.primary.main};
      stroke: ${({
  theme
}) => theme.primary.main};
    }
  }

  &:active {
    color: ${({
  theme
}) => theme.secondary.dark};
    border-color: ${({
  theme
}) => theme.secondary.dark};
    path {
      fill: ${({
  theme
}) => theme.secondary.dark};
      stroke: ${({
  theme
}) => theme.secondary.dark};
    }
  }

  &:disabled {
    cursor: default;
  }
`;
export const TextLike = styled.span`
  display: none;
  ${breakpoints.md} {
    margin-left: 2px;
    display: inline;
  }
`;
export const AmountLikes = styled.span`
  font-weight: 400;
  margin-left: 5px;
  ${breakpoints.md} {
    margin-left: 10px;
  }
`;